import monash2025Image2 from '../Images/optimized/m25_2_optimized.png';
import monash2025Image3 from '../Images/optimized/m25_3_optimized.png';
import monash2025Image4 from '../Images/optimized/m25_4_optimized.png';
import monash2025Image5 from '../Images/optimized/m25_5_optimized.png';
import terminullImage1 from '../Images/optimized/terminull_1.png';
import terminullImage2 from '../Images/optimized/terminull_2.png';
import terminullImage3 from '../Images/optimized/terminull_3.png';
import terminullImage4 from '../Images/optimized/terminull_4.png';
import terminullImage5 from '../Images/optimized/terminull_5.png';
import monash2024Image1 from '../Images/optimized/mc1.png';
import monash2024Image2 from '../Images/optimized/monash_2.png';
import monash2024Image3 from '../Images/optimized/monash_3.png';
import monash2024Image4 from '../Images/optimized/monash_4.png';
import monash2024Image5 from '../Images/optimized/monash_5.png';
import monash2024Image6 from '../Images/optimized/monash_6.png';

export const eventsData = [
  {
    id: 'monash-cup-2025',
    title: 'Monash Cup 2025',
    description: 'Highlights: Monash University hosted their Monash Cup 2025 at Project Play. This year\'s tournament featured teams competing in Valorant and Counter Strike 2.',
    images: [monash2025Image2, monash2025Image3, monash2025Image4, monash2025Image5]
  },
  {
    id: 'terminull-brigade-2025',
    title: 'Terminull Brigade Event 2025',
    description: 'Highlights: Project Play hosted the Terminull Brigade Event 2025. This event included time run for Terminull Brigade where players from Sunway University and Monash University compete with other players to beat the best time.',
    images: [terminullImage1, terminullImage2, terminullImage3, terminullImage4, terminullImage5]
  },
  {
    id: 'monash-cup-2024',
    title: 'Monash Cup 2024',
    description: 'Highlights: Monash University hosted their Monash Cup 2024 at Project Play. Monash Cup was held for 3 days and had teams competing in different games including:',
    additionalInfo: [
      'Counter Strike 2',
      'Valorant',
      'League of Legends'
    ],
    images: [
      monash2024Image1,
      monash2024Image2,
      monash2024Image3,
      monash2024Image4,
      monash2024Image5,
      monash2024Image6
    ]
  }
];
